<sml-drawer size="xs" class="tw-h-[747px]" [@slideInOut]>
  <!-- Header -->
  <div class="tw-block" header>
    <div class="tw-flex tw-gap-2 tw-justify-between">
      <p class="tw-mb-2">How To Use SeeMyLegacy</p>
      <button type="button" (click)="closeModal()">
        <i-icon name="close" [height]="'tw-h-6'" [width]="'tw-w-6'"></i-icon>
      </button>
    </div>
    <h3 class="text-[#010f12] tw-text-xl tw-font-bold tw-leading-7 tw-mb-1">
      {{ howtoData()?.name }}
    </h3>
    <p
      class="editorContentWrap tw-text-grey-750 tw-text-sm tw-leading-snug"
      [innerHTML]="howtoData()?.purpose | safe: 'html'"
    ></p>
  </div>
  <!-- END -->

  <!-- List of Filters -->
  <div class="" body>
    <div class="tw-block">
      
      <div class="tw-mt-6">
        @if (!!howtoData()?.videoEmbedCode?.trim()?.length) {
          <h5 class="text-[#010f12] tw-text-lg tw-font-bold tw-leading-7 tw-mb-1">
            Video Tutorial
          </h5>
  
          <div
            class="video-container tw-rounded-[20px] tw-overflow-hidden"
            [innerHTML]="howtoData()?.videoEmbedCode | safe: 'html'"
          >
          
          </div>
  
          <p
            class="editorContentWrap tw-text-grey-750 tw-text-sm tw-leading-snug tw-mt-2"
            [innerHTML]="howtoData()?.videoDescription | safe: 'html'"
          ></p>
      }

        <h5
          class="text-[#010f12] tw-text-lg tw-font-bold tw-leading-7 tw-mb-1 tw-mt-4"
        >
          Actions
        </h5>

        <div class="tw-flex tw-flex-col tw-gap-2 list-container tw-mt-2">
          @for (item of howtoData()?.howToActionModels; track $index) {
            <sml-accordion [heading]="item.actionName">
              <p
                class="editorContentWrap tw-text-sm"
                [innerHTML]="item.description | safe: 'html'"
              ></p>

              @if (item.actionImageUrl) {
                <div class="tw-flex tw-flex-col tw-gap-3 tw-mt-4">
                  @for (
                    image of item.actionImageUrl | blobUrlToList;
                    track $index
                  ) {
                    <p>
                      <img [src]="image?.BlobUrl" alt="Image URL" />
                    </p>
                  }
                </div>
              }
            </sml-accordion>
          }
        </div>
      </div>
    </div>
  </div>
  <!-- END -->

  <!-- Apply/Reset buttons -->
  <div class="tw-flex tw-items-center tw-justify-end" footer>
    <button
      type="button"
      [smlButton]="'link'"
      class="!tw-min-w-[100px] !tw-h-[40px]"
      (click)="closeModal()"
    >
      Close
    </button>
  </div>
  <!-- END -->
</sml-drawer>
